import { Route, Routes } from 'react-router-dom';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';
import { Discovery } from './components/Discovery';
import { DiscoveryProfile } from './components/DiscoveryProfile';
import { DiscoverySearch } from './components/DiscoverySearch';

export function DiscoveryRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.DISCOVERY) && (
                <>
                    <Route path="overview" element={<Discovery />} />
                    <Route path="profile" element={<DiscoveryProfile />} />
                    <Route path="search" element={<DiscoverySearch />} />
                </>
            )}
        </Routes>
    );
}
